<template>

<com-setting :options="options" :value="value" v-on:change="onChange" />

</template>

<script>

import comSetting from './Setting'

export default {

    props: ['type', 'value'],

    components: {
        'com-setting': comSetting
    },

    data: function() {

        return {
            name: {
                best: 'Best only',
                recommended: 'Best or recommended'
            },
            numeric: {},
            date: {}
        }

    },

    computed: {

        options: function() {

            var options = []

            this.$_.each(this.type.setting.count, function(logic) {

                options.push({
                    value: logic,
                    text: this[this.type.type][logic] || this.name[logic]
                })

            }.bind(this))

            return options

        }

    },

    methods: {

        onChange: function(value) {

            this.$emit('input', value)

        }
    
    }

}

</script>

<style scoped>

</style>